import axios from 'axios';
import { BUSINESS_ADMIN_HOST } from 'api/constants';
import {
  createErrorFromAxiosUserMessageError,
  createErrorFromAxiosMultipleErrors,
} from 'api/utilities';
import UserConcurrentError from 'constants/userConcurrent/error';

export async function deleteBusiness(businessId) {
  try {
    return await axios.delete(
      `${BUSINESS_ADMIN_HOST}/v1/businesses/${businessId}`
    );
  } catch (e) {
    if (
      [400, 422, 429].includes(e.response.status) &&
      UserConcurrentError.Codes.includes(e.response.data.code)
    ) {
      throw createErrorFromAxiosUserMessageError(e);
    }

    throw createErrorFromAxiosMultipleErrors(e);
  }
}

export async function getBulkDeleteBusinessLogs(page, size) {
  try {
    return await axios.get(
      `${BUSINESS_ADMIN_HOST}/v1/logs/actions?group=businesses&action=obfuscate_business`,
      {
        params: { page, size },
      }
    );
  } catch (e) {
    throw createErrorFromAxiosMultipleErrors(e);
  }
}
